import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

/**
 * Reusable confirm dialog. Use as:
 *   const [confirm, setConfirm] = useState(null);
 *   <ConfirmDialog
 *     open={!!confirm}
 *     onOpenChange={(o) => !o && setConfirm(null)}
 *     title="Elimina transazione?"
 *     description="L'operazione non è reversibile."
 *     confirmLabel="Elimina"
 *     destructive
 *     onConfirm={async () => { await deleteTx(confirm.id); setConfirm(null); }}
 *   />
 */
const ConfirmDialog = ({
  open,
  onOpenChange,
  title = 'Conferma',
  description = 'Sei sicuro di voler procedere?',
  confirmLabel = 'Conferma',
  cancelLabel = 'Annulla',
  destructive = false,
  onConfirm,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel-btn">{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-action-btn"
            onClick={(e) => {
              e.preventDefault();
              onConfirm?.();
            }}
            className={destructive ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90' : ''}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDialog;
